import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { QuickRenewFormStep } from './quick-renew.models';
import { AccountDetails, ValidateSucceededResponseObject } from '../types/types';
import { RequestError } from '../generic-errors';
import { ConnectSuite } from '../connect-suite.type';

export const QuickRenewActions = createActionGroup({
  source: 'Quick Renew',
  events: {
    'Initialize Login Form Data': props<{ token: string }>(),
    'Initialize Login Form Data Succeeded': props<ConnectSuite.AutologinQuickRenewResponseObject>(),
    'Initialize Login Form Data Failed': props<{ error: RequestError }>(),
    'Validate Form Step': props<{ validateStep: QuickRenewFormStep }>(),
    'Validate Form Step Succeeded': props<{ activeStep: QuickRenewFormStep }>(),
    'Validate Membership': emptyProps(),
    'Validate Membership Succeeded': emptyProps(),
    'Validate Membership Failed': emptyProps(),
    'Validate Payment Holder': emptyProps(),
    'Validate Payment Holder Succeeded': emptyProps(),
    'Validate Payment Holder Failed': emptyProps(),
    'Recost Validate': emptyProps(),
    'Recost Validate Succeeded': props<ValidateSucceededResponseObject>(),
    'Recost Validate Failed': props<{ error: RequestError }>(),
    Pay: emptyProps(),
    'Pay Succeeded': emptyProps(),
    'Pay Failed': props<{ error: RequestError }>(),
    'Clear Form': emptyProps(),
    'Reset Confirmation': emptyProps(),
    'Set Account Details': props<{ accountDetails: AccountDetails }>(),
  },
});
